import {Component} from '@angular/core';
import {
    ActionSheetController,
    AlertController,
    IonicPage,
    LoadingController,
    ModalController,
    NavController,
    NavParams,
    ToastController
} from 'ionic-angular';
import {ServiceProvider} from "../../providers/service/service";
import {AddCallReminderPage} from '../add-call-reminder/add-call-reminder';
import {Storage} from '@ionic/storage';
import {AddAppointmentPage} from "../add-appointment/add-appointment";
import {DataCallLogPage} from "../data-call-log/data-call-log";
import {SubStatusHistoryPage} from "../sub-status-history/sub-status-history";
import {SocialSharing} from "@ionic-native/social-sharing";
import {DatePipe} from "@angular/common";
import {EnquiryFormPage} from "../enquiry-form/enquiry-form";
import {PredataCallLogsPage} from "../predata-call-logs/predata-call-logs";
import {AddPredataCallReminderPage} from "../add-predata-call-reminder/add-predata-call-reminder";
import {errorHandler} from "@angular/platform-browser/src/browser";
/**
 * Generated class for the CallEnquiryReminderPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

//@IonicPage()
@Component({
    selector: 'page-call-enquiry-reminder',
    templateUrl: 'call-enquiry-reminder.html',
})
export class CallEnquiryReminderPage {


    School = 'GEIS';
    SchoolId = 1;

    data = 'Today';
    daysStatusId = 2;

    Status = 'Data'
    subStatusId = 1;

    StatusPending = 'Pending';
    pendingorCompleted = 1;

    searchText: string = "";

    pending_enquiry: any[];
    completed_enquiry: any[];

    pending_enquiry1: any[];
    completed_enquiry1: any[];

    negative_enquiry: any[];
    positive_enquiry: any[];
    autopostpone_enquiry: any[];
    autoArchive_enquiry: any[];

    negative_enquiry1: any[];
    positive_enquiry1: any[];
    autopostpone_enquiry1: any[];
    autoArchive_enquiry1: any[];


    CallStatus: any;
    CallStatusItem: any;

    FUserId: any;
    userName: any;

    tommorowCount: any;
    todayCount: any;
    yestardayCount: any;
    fivedayCount: any;
    thirtydayCount: any;
    pastdayCount: any;
    futuredayCount: any;

    PreDataCount: any;
    DataCount: any;
    AptCount: any;
    EnqCount: any;
    FBCount: any;

    DataCountPast: any;
    AptCountPast: any;
    EnqCountPast: any;
    FBCountPast: any;

    pendingCount: any
    completedCount: any;

    positivecount: any;
    negativecount: any;
    postponedcount: any;
    autoArchivecount: any;

    FCallStatusId: any;

    ArchiveStatus: any;
    ArchiveStatusItem;

    datareports: any;
    enquiryreport: any;
    aptreport: any;
    fbreport: any

    SharingData;

    SubStatus: any;
    SubStatusItem: any;

    Date: any = Date.now();

    constructor(public navCtrl: NavController, public navParams: NavParams, public storage: Storage, public datepipe: DatePipe,
                public service: ServiceProvider, public loadingCtrl: LoadingController, public alertCtrl: AlertController,
                public modalCtrl: ModalController, public toastCtrl: ToastController, public socialSharing: SocialSharing, public actionSheetCtrl: ActionSheetController) {
        Promise.all([this.storage.get('LoginData'), this.storage.get('UserData')]).then(values => {

            this.FUserId = values[0]['FUserId'];
            this.userName = values[1]['Name'];
            console.log(this.userName);

        });
        this.load_archive_status();
        this.get_call_reminders();
        this.share_report_on_whatsup();
    }

    ionViewDidLoad() {
        console.log('ionViewDidLoad CallEnquiryReminderPage');
    }


    active_School_tab(tab, schoolId) {
        this.searchText = "";
        console.log(tab, schoolId);
        this.SchoolId = schoolId;
        this.School = tab;
        this.share_report_on_whatsup();
        this.active_status_tab(this.Status, this.subStatusId);
    }


    active_data_tab(tab, daysId) {
        this.searchText = "";
        console.log(tab, daysId);

        if (tab == 'Tommorow' || tab == 'Today' || tab == 'future') {
            this.StatusPending = 'Pending'
        } else {
            this.StatusPending = 'Negative';
        }
        this.data = tab;
        this.daysStatusId = daysId;
        this.get_count();

        if (this.Status == "PreData") {
            this.get_predata_call_reminder();
        } else {
            this.get_call_reminders();
        }

    }

    active_status_tab(tab, subId) {
        this.searchText = "";
        console.log(tab, subId);
        this.Status = tab;
        this.subStatusId = subId;
        this.get_count();
        if (this.Status == "PreData") {
            this.get_predata_call_reminder();
        } else {
            this.get_call_reminders();
        }
    }


    active_status_pending_tab(tab, Id) {
        this.searchText = "";
        this.StatusPending = tab;
        this.pendingorCompleted = Id;
        this.get_count();
        if (this.Status == "PreData") {
            this.get_predata_call_reminder();
        } else {
            this.get_call_reminders();
        }



    }

    get_count(){
        this.service.httppostcall("app_web_service/get_todays_call_reminder?SchoolId=" + this.SchoolId + '&FStatusId=' + this.subStatusId + '&DayId=' + this.daysStatusId, '').subscribe(data => {
            console.log(data);
            this.tommorowCount = data['tommorow'];
            this.todayCount = data['today'];
            this.yestardayCount = data['yestarday'];
            this.fivedayCount = data['5day'];
            this.thirtydayCount = data['30day'];
            this.pastdayCount = data['past'];
            this.futuredayCount = data['future'];

            this.PreDataCount=data['PreDataCount'];
            this.DataCount = data['DataCount'];
            this.AptCount = data['AptCount'];
            this.EnqCount = data['EnqCount'];
            this.FBCount = data['FBCount'];

            this.DataCountPast = data['DataCountPast'];
            this.AptCountPast = data['AptCountPast'];
            this.EnqCountPast = data['EnqCountPast'];
            this.FBCountPast = data['FBCountPast'];

            this.completedCount = data['completedCount'];
            this.pendingCount = data['pendingCount'];

            this.positivecount = data['positivecount'];
            this.negativecount = data['negativecount'];
            this.postponedcount = data['postponedcount'];
            this.autoArchivecount = data['autoarchivecount'];

            if (this.Status == "PreData") {
                this.service.httppostcall("app_web_service/get_predata_call_reminder?SchoolId=" + this.SchoolId + '&DayId=' + this.daysStatusId, '').subscribe(data => {
                    console.log(data);
                    this.completedCount = this.completedCount + data['completedCount'];
                    this.pendingCount = this.pendingCount + data['pendingCount'];
                });
            }


        });


    }

    get_call_reminders() {
        this.searchText = "";

        let loading = this.loadingCtrl.create({
            content: 'please wait...',
            enableBackdropDismiss: false
        });

        loading.present();

        setTimeout(() => {
            console.log('Async operation has ended');
            loading.dismiss();
        }, 1000);

        this.service.httppostcall("app_web_service/get_todays_call_reminder?SchoolId=" + this.SchoolId + '&FStatusId=' + this.subStatusId + '&DayId=' + this.daysStatusId, '').subscribe(data => {
            console.log(data);
            loading.dismiss();
            this.pending_enquiry = data['pending'];
            this.completed_enquiry = data['completed'];

            this.positive_enquiry = data['positive'];
            this.negative_enquiry = data['negative'];
            this.autopostpone_enquiry = data['postponed'];
            this.autoArchive_enquiry = data['autoArchive'];

            this.pending_enquiry1 = this.pending_enquiry;
            this.completed_enquiry1 = this.completed_enquiry;

            this.positive_enquiry1 = this.positive_enquiry;
            this.negative_enquiry1 = this.negative_enquiry;
            this.autopostpone_enquiry1 = this.autopostpone_enquiry;

            this.tommorowCount = data['tommorow'];
            this.todayCount = data['today'];
            this.yestardayCount = data['yestarday'];
            this.fivedayCount = data['5day'];
            this.thirtydayCount = data['30day'];
            this.pastdayCount = data['past'];
            this.futuredayCount = data['future'];

            this.PreDataCount=data['PreDataCount'];
            this.DataCount = data['DataCount'];
            this.AptCount = data['AptCount'];
            this.EnqCount = data['EnqCount'];
            this.FBCount = data['FBCount'];

            this.DataCountPast = data['DataCountPast'];
            this.AptCountPast = data['AptCountPast'];
            this.EnqCountPast = data['EnqCountPast'];
            this.FBCountPast = data['FBCountPast'];

            this.completedCount = data['completedCount'];
            this.pendingCount = data['pendingCount'];

            this.positivecount = data['positivecount'];
            this.negativecount = data['negativecount'];
            this.postponedcount = data['postponedcount'];
            this.autoArchivecount = data['autoarchivecount'];


        });
    }

    add_call_reminder(item) {
        this.navCtrl.push(AddCallReminderPage, {'item': item, 'FCallStatusId': this.subStatusId, 'changeStatus': '0'});
    }

    msg_Group(item) {
        console.log("item->", item);
        console.log("SendWhatsAppGroupMsg->", item.SendWhatsAppGroupMsg);
        if (item.FStatusId == '2') {
            let msg = "*" + item.SchoolAbbreviations + " Appointment*\n" +
                "Student Name: " + item.Name + " - " + item.StandardName + "(" + item.FDataId + ")\n" +
                "Date: " + this.datepipe.transform(item.AppointmentDate, 'dd-MMM-yyyy') + "\n" +
                "Slot: " + item.AppointmentFrom + " - " + item.AppointmentTo + "\n" +
                "Appointment By: " + item.AptAddedByName + "\n" +
                "DataAdded By: " + item.AddedByData + "\n" +
                "Source: " + item.Source;

            console.log("SendWhatsAppGroupMsg->", msg);
            this.socialSharing.shareViaWhatsApp(msg, null, null);
        } else {
            this.socialSharing.shareViaWhatsApp(item.SendWhatsAppGroupMsg, null, null);
        }

    }

    call(item) {
        let myAlert = this.alertCtrl.create({
            title: 'Contacts',
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel',
                    handler: () => {
                        console.log('Cancel clicked');
                    }
                },
                {
                    text: 'Call',
                    handler: (data) => {
                        console.log('Message clicked');
                        console.log(data);

                        if (data) {
                            let loading = this.loadingCtrl.create({
                                content: 'Loading',
                                enableBackdropDismiss: false
                            });
                            loading.present();


                            var formdata = new FormData();
                            formdata.append("FWebEnquiryId", item.FWebEnquiryId);
                            formdata.append("AddedBy", this.FUserId);
                            formdata.append("CallTo", data);
                            formdata.append("CallType", "2");
                            formdata.append("FileName", "text");
                            // formdata.append("CallFor",this.CallFor);


                            this.service.httppostFormcall('web_service/add_enquiry_call_logs', formdata).subscribe(resdata => {
                                console.log(resdata);
                                if (resdata['response'] == 'success') {
                                    var LogId = resdata['LogId'];
                                    if (loading)
                                        loading.dismiss();
                                    loading = undefined;
                                    window.location.href = 'tel:' + data;
                                } else {
                                    if (loading)
                                        loading.dismiss();
                                    loading = undefined;
                                }
                            }, (err) => {
                                if (loading)
                                    loading.dismiss();
                                loading = undefined;
                            });
                        } else {
                            this.service.showAlert("Warning!", "Select any one is required!")
                        }


                    }
                }
            ]
        });
        myAlert.addInput({
            type: 'radio',
            label: item.Phone1,
            value: item.Phone1
        })

        if (item.Phone2) {
            myAlert.addInput({
                type: 'radio',
                label: item.Phone2,
                value: item.Phone2
            })
        }


        myAlert.present();
    }

    gotoCallLogs(item) {
        let Call_logs_model = this.modalCtrl.create(DataCallLogPage, {
            FWebEnquiryId: item.FWebEnquiryId,
            FDataId: item.FDataId,
            Tab: 5
        });
        Call_logs_model.present();
    }

    whatsapp_call(enquirydata) {

        let myAlert = this.alertCtrl.create({
            title: 'Contacts',
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel',
                    handler: () => {
                        console.log('Cancel clicked');
                    }
                },
                {
                    text: 'Whatsapp',
                    handler: (data) => {
                        console.log('Message clicked');
                        console.log(data);
                        if (data) {
                            window.location.href = 'whatsapp://send?phone=+91' + data;
                        } else {
                            this.service.showAlert("Warning!", "Select any one is required!")
                        }
                    }
                }
            ]
        });

        myAlert.addInput({
            type: 'radio',
            label: enquirydata.Phone1,
            value: enquirydata.Phone1
        })

        if (enquirydata.Phone2) {
            myAlert.addInput({
                type: 'radio',
                label: enquirydata.Phone2,
                value: enquirydata.Phone2
            })
        }
        myAlert.present();


    }

    sms(enquirydata) {

        let myAlert = this.alertCtrl.create({
            title: 'Contacts',
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel',
                    handler: () => {
                        console.log('Cancel clicked');
                    }
                },
                {
                    text: 'Message',
                    handler: (data) => {
                        console.log('Message clicked');
                        console.log(data);
                        if (data) {
                            window.location.href = 'sms:' + data;
                        } else {
                            this.service.showAlert("Warning!", "Select any one is required!")
                        }
                    }
                }
            ]
        });

        if (this.Status == "PreData") {
            myAlert.addInput({
                type: 'radio',
                label: enquirydata.MobileNumber,
                value: enquirydata.MobileNumber
            })
        } else {
            myAlert.addInput({
                type: 'radio',
                label: enquirydata.Phone1,
                value: enquirydata.Phone1
            })

            if (enquirydata.Phone2) {
                myAlert.addInput({
                    type: 'radio',
                    label: enquirydata.Phone2,
                    value: enquirydata.Phone2
                })
            }
        }


        myAlert.present();


    }

    change_call_status(item) {

        let send_data = {
            FWebEnquiryId: item['FWebEnquiryId'],
            FDataId: item['FDataId'],
            FStatusId: item['FStatusId'],
            Name: item['Name'],
            SchoolId: item['SchoolId'],
            Phone1: item['Phone1'],
            Phone2: item['Phone2'],
            Standard: item['Standard'],
            ReminderDate: item['ReminderDate'],
            CreatedByName: this.userName,
            FUserId: this.FUserId
        };

        this.CallStatus = null;
        this.CallStatusItem = null;

        this.service.httpcall('web_service/get_master_call_log_status?').subscribe(data => {

            console.log("get_master_call_log_status", data);

            if (data != "") {

                this.CallStatus = data;

                console.log(this.CallStatus);

                let myAlert = this.alertCtrl.create({
                    title: 'Set Call Status',
                    buttons: [
                        {
                            text: 'Cancel',
                            role: 'cancel',
                            handler: () => {
                                console.log('Cancel clicked');
                            }
                        },
                        {
                            text: 'Confirm',
                            handler: (data) => {
                                console.log('clicked');
                                console.log(data, " ", item);

                                if (data) {


                                    this.FCallStatusId = data;

                                    if (data == 11 || data == 12) {
                                        let aptData = {
                                            Id: item['FWebEnquiryId'],
                                            FCallReminderId: item['Id'],
                                            FCallStatusId: data,
                                            Siblings: item['Siblings'],
                                            CommonId: item['CommonId'],
                                            FUserId: this.FUserId
                                        }
                                        this.Create_alert(aptData, item, data);
                                    }
                                    else if (data == 10) {
                                        this.Create_alert_reminder(item, data);
                                    }
                                    else {

                                        let loading = this.loadingCtrl.create({
                                            content: 'Please wait...'
                                        });
                                        loading.present();


                                        this.service.httppostcall('app_web_service/add_callStatus_On_reminder?FCallReminderId=' + item.Id + '&FCallStatusId=' + data + '&FUserId=' + this.FUserId + '&UpdatedByName=' + this.userName, send_data).subscribe(data1 => {
                                                console.log(data1);
                                                loading.dismiss();
                                                if (data1['status'] == "success") {

                                                } else {
                                                    loading.dismiss();
                                                }
                                            }
                                            , (error2 => {

                                            }))
                                    }
                                } else {
                                    this.service.showAlert("Warning!", "Select any one is required!")
                                }

                            }
                        }
                    ]
                });

                for (var i = 0; i < this.CallStatus.length; i++) {
                    this.CallStatusItem = this.CallStatus[i];
                    var edata = this.CallStatusItem.Name;
                    console.log(edata);
                    myAlert.addInput({
                        type: 'radio',
                        label: edata,
                        value: this.CallStatusItem.Id
                    })
                }

                myAlert.present();
            } else {
                //this.presentToast(data['error_description']);
            }
        }, (error2 => {
            //this.presentToast("Timeout!");
        }))
    }


    Create_alert(aptdata, callData, FCallStatusId) {

        let button = {};
        if (this.subStatusId == 2) {
            button = {
                text: 'Reschedule Appointment',
                handler: () => {
                    this.navCtrl.push(AddAppointmentPage, {
                        'aptData': callData,
                        'callReminder': aptdata,
                        'Reschedule': '1'
                    });
                }
            };
        }
        else if (this.subStatusId == 1) {
            button = {
                text: 'Add Appointment',
                handler: () => {
                    this.navCtrl.push(AddAppointmentPage, {'callReminder': aptdata});
                }
            };
        }
        else if (this.subStatusId == 3) {
            button = {
                text: 'Confirm Enquiry Status',
                handler: () => {
                    this.service.httppostcall('app_web_service/add_callStatus_On_reminder?FCallReminderId=' + callData['Id'] + '&FCallStatusId=' + aptdata['FCallStatusId'] + '&FUserId=' + this.FUserId + '&UpdatedByName=' + this.userName, '').subscribe
                    (data => {
                            if (data['status'] == 'success') {
                                this.get_call_reminders();
                            }
                        }
                        , (error2 => {

                        }))
                }
            };
        }
        else if (this.subStatusId == 4) {
            button = {
                text: 'Confirm FB Status',
                handler: () => {
                    this.service.httppostcall('app_web_service/add_callStatus_On_reminder?FCallReminderId=' + callData['Id'] + '&FCallStatusId=' + aptdata['FCallStatusId'] + '&FUserId=' + this.FUserId + '&UpdatedByName=' + this.userName, '').subscribe(data => {
                            if (data['status'] == 'success') {
                                this.get_call_reminders();
                            }
                        }
                        , (error2 => {

                        }))
                }
            };
        }

        let myAlert = this.alertCtrl.create({
            title: 'Update Status',
            subTitle: 'Add Appointment Or Reminder',
            enableBackdropDismiss: false,
            buttons: [

                button,
                {
                    text: 'Add Reminder',
                    handler: (data) => {
                        this.navCtrl.push(AddCallReminderPage, {
                            'item': callData,
                            'FCallStatusId': FCallStatusId,
                            'changeStatus': '1'
                        });
                    }
                },
                // {
                //     text: 'Archive',
                //     handler: (data) => {
                //         this.Apmt_select_archive(callData);
                //     }
                // },
                {
                    text: 'Coming Today',
                    handler: (data) => {
                        this.add_status_coming_today(callData);
                    }
                },
                {
                    text: 'Cancel',
                    role: 'cancel',
                    cssClass: 'alertCancleCss',
                    handler: () => {
                        console.log('Cancel clicked');
                    }
                },

            ]
        });

        myAlert.present();
    }

    add_status_coming_today(item) {
        let myAlert = this.alertCtrl.create({
            title: 'Update Status',
            subTitle: 'Confirm',
            enableBackdropDismiss: false,
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel',
                    handler: () => {
                        console.log('Cancel clicked');
                    }
                },
                {
                    text: 'Confirm',
                    handler: () => {
                        let loading = this.loadingCtrl.create({
                            content: 'Please wait...'
                        });
                        loading.present();
                        this.service.httppostcall('app_web_service/add_callStatus_On_reminder?FCallReminderId=' + item.Id + '&FCallStatusId=16' + '&FUserId=' + this.FUserId + '&UpdatedByName=' + this.userName, '').subscribe(data1 => {
                                loading.dismiss();
                                if (data1['status'] == "success") {

                                } else {
                                    loading.dismiss();
                                }
                            }
                            , (error2 => {

                            }))
                    }
                }

            ]
        });

        myAlert.present();

    }

    Create_alert_reminder(callData, FCallStatusId) {
        let myAlert = this.alertCtrl.create({
            title: 'Update Status',
            subTitle: 'Add  Reminder',
            enableBackdropDismiss: false,
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel',
                    handler: () => {
                        console.log('Cancel clicked');
                    }
                },
                {
                    text: 'Add Reminder',
                    handler: (data) => {
                        this.navCtrl.push(AddCallReminderPage, {
                            'item': callData,
                            'FCallStatusId': FCallStatusId,
                            'changeStatus': '1'
                        });
                    }
                }
            ]
        });

        myAlert.present();
    }

    searchData() {
        // Reset items back to all of the items
        //this.pending_enquiry = this.pending_enquiry1;
        this.pending_enquiry = this.pending_enquiry1;

        if (this.searchText.trim() !== '') {
            this.pending_enquiry = this.pending_enquiry.filter((item) => {
                return (item.Name.toLowerCase().indexOf(this.searchText.toLowerCase()) > -1);
            });
        }

    }

    searchData1() {
        // Reset items back to all of the items
        //this.pending_enquiry = this.pending_enquiry1;
        this.completed_enquiry = this.completed_enquiry1;

        if (this.searchText.trim() !== '') {
            this.completed_enquiry = this.completed_enquiry.filter((item) => {
                return (item.Name.toLowerCase().indexOf(this.searchText.toLowerCase()) > -1);
            });
        }

    }

    searchData_negative(id) {

        if (id == 1) {
            console.log("postive");
            this.positive_enquiry = this.positive_enquiry1;

            if (this.searchText.trim() !== '') {
                this.positive_enquiry = this.positive_enquiry.filter((item) => {
                    return (item.Name.toLowerCase().indexOf(this.searchText.toLowerCase()) > -1) || (item.FDataId.toLowerCase().indexOf(this.searchText.toLowerCase()) > -1);
                });
            }
        }
        else if (id == 2) {
            console.log("negative");
            this.negative_enquiry = this.negative_enquiry1;

            if (this.searchText.trim() !== '') {
                this.negative_enquiry = this.negative_enquiry.filter((item) => {
                    return (item.Name.toLowerCase().indexOf(this.searchText.toLowerCase()) > -1) || (item.FDataId.toLowerCase().indexOf(this.searchText.toLowerCase()) > -1);
                });
            }
        }
        else if (id == 3) {
            console.log("auto postponed");
            this.autopostpone_enquiry = this.autopostpone_enquiry1;

            if (this.searchText.trim() !== '') {
                this.autopostpone_enquiry = this.autopostpone_enquiry.filter((item) => {
                    return (item.Name.toLowerCase().indexOf(this.searchText.toLowerCase()) > -1) || (item.FDataId.toLowerCase().indexOf(this.searchText.toLowerCase()) > -1);
                });
            }
        }
        else if (id == 4) {
            console.log("auto postponed");
            this.autoArchive_enquiry = this.autoArchive_enquiry1;

            if (this.searchText.trim() !== '') {
                this.autoArchive_enquiry = this.autoArchive_enquiry.filter((item) => {
                    return (item.Name.toLowerCase().indexOf(this.searchText.toLowerCase()) > -1) || (item.FDataId.toLowerCase().indexOf(this.searchText.toLowerCase()) > -1);
                });
            }
        }

    }


    doRefresh(refresher) {
        this.searchText = ""

        this.get_count();
        if (this.Status == "PreData") {
            this.get_predata_call_reminder();
        } else {
            this.get_call_reminders();
        }

        setTimeout(() => {
            console.log('Async operation has ended');

            refresher.complete();
        }, 2000);
    }


    load_archive_status() {
        this.ArchiveStatus = [];
        this.service.httpcall('web_service/get_master_archive_status?').subscribe(data => {
            this.ArchiveStatus = data;
        })
    }

    Apmt_select_archive(item) {
        let myAlert = this.alertCtrl.create({
            title: 'Select Archive',
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel',
                    handler: () => {
                        console.log('Cancel clicked');
                    }
                },
                {
                    text: 'Confirm',
                    handler: (data) => {
                        console.log('clicked');
                        console.log(data);

                        let SchoolName = '';
                        if (data == 1) {
                            let myAlert1 = this.alertCtrl.create({
                                title: 'Enter School Name',
                                inputs: [
                                    {
                                        name: 'SchoolName',
                                        placeholder: 'School Name'
                                    },
                                ],
                                buttons: [
                                    {
                                        text: 'Cancel',
                                        role: 'cancel',
                                        handler: () => {
                                            console.log('Cancel clicked');
                                        }
                                    },
                                    {
                                        text: 'Confirm',
                                        handler: (data1) => {
                                            console.log('clicked');
                                            console.log(data1.SchoolName);
                                            SchoolName = data1.SchoolName;

                                            let loading = this.loadingCtrl.create({
                                                content: 'Loading'
                                            });

                                            setTimeout(() => {
                                                console.log('Async operation has ended');
                                                loading.dismiss();
                                            }, 1000);
                                            loading.present();


                                            console.log("Id", item.FWebEnquiryId);
                                            this.service.httpcall('web_service/update_web_enquiry_as_testing?SchoolName=' + SchoolName + '&CancelledBy=' + this.FUserId + 'Id=' + item.FWebEnquiryId + '&Active=' + 3 + '&ArchiveStatus=' + data).subscribe(data => {
                                                if (loading)
                                                    loading.dismiss();
                                                loading = undefined;
                                                console.log(data);
                                                if (data['response'] == "success") {
                                                    this.presentToast(data['success_message']);

                                                    this.service.httppostcall('app_web_service/add_callStatus_On_reminder?FCallReminderId=' + item.Id + '&FCallStatusId=' + this.FCallStatusId + '&FUserId=' + this.FUserId + '&UpdatedByName=' + this.userName, '').subscribe(data1 => {

                                                        }
                                                        , (error2 => {

                                                        }))

                                                } else {

                                                }
                                            })
                                        }
                                    }]
                            });

                            myAlert1.present();
                            console.log("Archive1->", data);

                        }
                        else {
                            let loading = this.loadingCtrl.create({
                                content: 'Loading'
                            });

                            setTimeout(() => {
                                console.log('Async operation has ended');
                                loading.dismiss();
                            }, 1000);
                            loading.present();


                            console.log("Id", item.FWebEnquiryId);
                            this.service.httpcall('web_service/update_web_enquiry_as_testing?SchoolName=' + SchoolName + '&CancelledBy=' + this.FUserId + 'Id=' + item.FWebEnquiryId + '&Active=' + 3 + '&ArchiveStatus=' + data).subscribe(data => {
                                if (loading)
                                    loading.dismiss();
                                loading = undefined;
                                console.log(data);
                                if (data['response'] == "success") {
                                    this.presentToast(data['success_message']);

                                    this.service.httppostcall('app_web_service/add_callStatus_On_reminder?FCallReminderId=' + item.Id + '&FCallStatusId=' + this.FCallStatusId + '&FUserId=' + this.FUserId + '&UpdatedByName=' + this.userName, '').subscribe(data1 => {

                                        }
                                        , (error2 => {

                                        }))

                                } else {

                                }
                            })
                        }


                    }
                }
            ]
        });
        for (var i = 0; i < this.ArchiveStatus.length; i++) {
            this.ArchiveStatusItem = this.ArchiveStatus[i];
            var edata = this.ArchiveStatusItem.Name;
            console.log(edata);
            myAlert.addInput({
                type: 'radio',
                label: edata,
                value: this.ArchiveStatusItem.Id
            })
        }

        myAlert.present();
    }

    presentToast(msg) {
        let toast = this.toastCtrl.create({
            message: msg,
            duration: 3000,
            position: 'bottom'
        });
        toast.present();
    }

    share_report_on_whatsup() {

        this.service.httppostcall("app_web_service/get_reminder_daily_report_data?SchoolId=" + this.SchoolId, "").subscribe(data => {

            this.datareports = data['data'];
            this.enquiryreport = data['enq'];
            this.aptreport = data['apt'];
            this.fbreport = data['fb'];

            console.log("report", this.datareports);
            var DataText = "Daily Calling Report of " + this.School + " for " + data['date'] + "\n";
            var EnqText = "";
            var AptText = "";
            var FbText = "";
            var status = "";


            for (var i = 0; i < this.datareports.length; i++) {
                if (+this.datareports[i]['CallStatusId'] == 1) {
                    DataText += "\n" + this.datareports[i]['FDataId'] + "(Data) - ";
                    DataText += this.datareports[i]['StandardName'] + " (" + this.datareports[i]['CallStatusName'] + ") (pending) \n";
                }
                else {
                    DataText += "\n" + this.datareports[i]['FDataId'] + "(Data) - ";
                    DataText += this.datareports[i]['StandardName'] + " (" + this.datareports[i]['CallStatusName'] + ")" + "(" + this.datareports[i]['UpdatedDate'] + " ) by " + this.datareports[i]['UpdatedByName'] + "\n";
                }
            }


            for (var i = 0; i < this.aptreport.length; i++) {
                if (+this.aptreport[i]['CallStatusId'] == 1) {
                    AptText += "\n" + this.aptreport[i]['FDataId'] + "(Apt) - ";
                    AptText += this.aptreport[i]['StandardName'] + " (" + this.aptreport[i]['CallStatusName'] + ") (pending) \n";
                }
                else {
                    AptText += "\n" + this.aptreport[i]['FDataId'] + "(Apt) - ";
                    AptText += this.aptreport[i]['StandardName'] + " (" + this.aptreport[i]['CallStatusName'] + ")" + "(" + this.aptreport[i]['UpdatedDate'] + " ) by " + this.aptreport[i]['UpdatedByName'] + "\n";
                }
            }

            for (var i = 0; i < this.enquiryreport.length; i++) {
                if (+this.enquiryreport[i]['CallStatusId'] == 1) {
                    EnqText += "\n" + this.enquiryreport[i]['FDataId'] + "(Enq) - ";
                    EnqText += this.enquiryreport[i]['StandardName'] + " (" + this.enquiryreport[i]['CallStatusName'] + ") (pending) \n";
                }
                else {
                    EnqText += "\n" + this.enquiryreport[i]['FDataId'] + "(Enq) - ";
                    EnqText += this.enquiryreport[i]['StandardName'] + " (" + this.enquiryreport[i]['CallStatusName'] + ")" + "(" + this.enquiryreport[i]['UpdatedDate'] + " ) by " + this.enquiryreport[i]['UpdatedByName'] + "\n";
                }
            }


            for (var i = 0; i < this.fbreport.length; i++) {
                if (+this.fbreport[i]['CallStatusId'] == 1) {
                    FbText += "\n" + this.fbreport[i]['FDataId'] + "(Fb) - ";
                    FbText += this.fbreport[i]['StandardName'] + " (" + this.fbreport[i]['CallStatusName'] + ") (pending) \n";
                }
                else {
                    FbText += "\n" + this.fbreport[i]['FDataId'] + "(Fb) - ";
                    FbText += this.fbreport[i]['StandardName'] + " (" + this.fbreport[i]['CallStatusName'] + ")" + "(" + this.fbreport[i]['UpdatedDate'] + " ) by " + this.fbreport[i]['UpdatedByName'] + "\n";
                }
            }

            // this.ShareDatawhatsapp = DataText;

            status = "Status Not Updated : " + data['StatusNotUpdated'] + "\n"
                + "Number is busy : " + data['Numberisbusy'] + "\n"
                + "Number is switchedoff : " + data['Numberisswitchedoff'] + "\n"
                + "Number is not reachable : " + data['Numbernotreachable'] + "\n"
                + "Didnot answer the call : " + data['Didnotanswerthecall'] + "\n"
                + "Call was disconnected / network Problem: " + data['Callwasdisconnectednetwork'] + "\n"
                + "Call is on waiting : " + data['Callisonwaiting'] + "\n"
                + "Call connected but could not hear anything : " + data['Callconnectedbutcouldnothearanything'] + "\n"
                + "Ask to Call Later : " + data['AsktoCallLater'] + "\n"
                + "Call connected : " + data['Callconnected'] + "\n"
                + "Received IncomingCall : " + data['ReceivedIncomingCall'] + "\n"
                + "Could not call today : " + data['Couldnotcalltoday'] + "\n";


            console.log(DataText + "\n" + AptText + "\n" + EnqText + "\n" + FbText + "\n" + status);
            this.SharingData = DataText + "\n" + AptText + "\n" + EnqText + "\n" + FbText + "\n" + status;

        })
    }

    openWhatsup() {
        console.log(this.SharingData);
        this.socialSharing.shareViaWhatsApp(this.SharingData, "", "").then(() => {
            // Success!
            console.log("success");
        }).catch(() => {
            // Error!
            console.log("Error");
        });

    }

    sendCnCMsg(item, btn) {
        let moduleId;
        if (this.subStatusId == 1) {
            moduleId = 5;
        }
        else if (this.subStatusId == 2) {
            moduleId = 6;
        }
        else if (this.subStatusId == 3) {
            moduleId = 7;
        }
        else if (this.subStatusId == 4) {
            moduleId = 8;
        }
        console.log(this.subStatusId);
        console.log(moduleId);
        this.service.httppostcall("predefined_module_message/get_predefined_module_message_by_id?ModuleId=" + moduleId, "").subscribe(data => {
            console.log(data);

            let button = [];
            for (let i = 0; i < data['data'].length; i++) {
                let button1 = {
                    text: data['data'][i]['DisplayName'],
                    handler: () => {
                        let message = this.replaceMessageWithString(item, data['data'][i]['Message'])
                        let myAlert = this.alertCtrl.create({
                            title: 'CNC Msg',
                            buttons: [
                                {
                                    text: 'Cancel',
                                    role: 'cancel',
                                    handler: () => {
                                        console.log('Cancel clicked');
                                    }
                                },
                                {
                                    text: 'Send',
                                    handler: (data) => {
                                        console.log('Message clicked', message);
                                        console.log(data);

                                        this.socialSharing.shareViaWhatsAppToReceiver('+91' + data, message, null, null);

                                    }
                                }
                            ]
                        });
                        myAlert.addInput({
                            type: 'radio',
                            label: item.Phone1,
                            value: item.Phone1
                        });

                        if (item.Phone2) {
                            myAlert.addInput({
                                type: 'radio',
                                label: item.Phone2,
                                value: item.Phone2
                            })
                        }


                        myAlert.present();
                    }
                };

                button.push(button1);
            }

            let Cancel = {
                text: 'Cancel',
                handler: () => {

                }
            }

            button.push(Cancel);

            this.presentActionSheet('Actions', button);
        });
    }

    sendCnCMsgTest(item, btn) {

        console.log("item->", item);
        console.log("btn->", btn);


        var message = null;

        if (item['FStatusId'] == 1) {
            if (btn == 1) {
                message = this.replaceMessageWithString(item, item['DataMsgBtn1']);
            }
            if (btn == 2) {
                message = this.replaceMessageWithString(item, item['DataMsgBtn2']);
            }
        }
        if (item['FStatusId'] == 2) {
            if (btn == 1) {
                message = this.replaceMessageWithString(item, item['AptMsgBtn1']);
            }
            if (btn == 2) {
                message = this.replaceMessageWithString(item, item['AptMsgBtn2']);
            }
        }
        if (item['FStatusId'] == 3) {
            if (btn == 1) {
                message = this.replaceMessageWithString(item, item['EnqMsgBtn1']);
            }
            if (btn == 2) {
                message = this.replaceMessageWithString(item, item['EnqMsgBtn2']);
            }
        }
        if (item['FStatusId'] == 4) {
            if (btn == 1) {
                message = this.replaceMessageWithString(item, item['FbMsgBtn1']);
            }
            if (btn == 2) {
                message = this.replaceMessageWithString(item, item['FbMsgBtn2']);
            }
        }

        console.log("return_message->", message);

        let myAlert = this.alertCtrl.create({
            title: 'CNC Msg',
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel',
                    handler: () => {
                        console.log('Cancel clicked');
                    }
                },
                {
                    text: 'Send',
                    handler: (data) => {
                        console.log('Message clicked', message);
                        console.log(data);

                        this.socialSharing.shareViaWhatsAppToReceiver('+91' + data, message, null, null);

                    }
                }
            ]
        });
        myAlert.addInput({
            type: 'radio',
            label: item.Phone1,
            value: item.Phone1
        })

        if (item.Phone2) {
            myAlert.addInput({
                type: 'radio',
                label: item.Phone2,
                value: item.Phone2
            })
        }


        myAlert.present();

    }

    presentActionSheet(title, buttons) {
        const actionSheet = this.actionSheetCtrl.create({
            title: title,
            buttons
        });
        actionSheet.present();
    }

    replaceMessageWithString(item, msg) {
        var link = "http://geis.co.in/add_appointment.php?FWebEnquiryId=" + item['FWebEnquiryId'] + "&Name=" + item['Name'];

        var rname = /#name/gi;
        var rschool = /#school/gi;
        var rsource = /#source/gi;
        var rdate = /#date/gi;
        var rstd = /#std/gi;

        var raptLink = /#aptlink/gi;
        var rlocation = /#location/gi;
        var rusername = /#user/gi;

        var raptdate = /#aptdate/gi;
        var raptdatetime = /#aptdatetime/gi;
        var rapttime = /#apttime/gi;

        var rfeedbacklink = /#feedbacklink/gi;


        var newstr = msg.replace(rname, item['Name']);
        var newstr1 = newstr.replace(rschool, item['SchoolName']);
        var newstr2 = newstr1.replace(rsource, item['Source']);
        var newstr3 = newstr2.replace(rstd, item['StandardName']);
        var newstr4 = newstr3.replace(rdate, this.datepipe.transform(item['WebEnquiryDate'], 'dd-MMM-yyyy'));
        var newstr5 = newstr4.replace(raptLink, link);
        var newstr6 = newstr5.replace(rusername, this.userName);
        var newstr7 = newstr6.replace(rlocation, item['SchoolLocation']);

        var newstr8 = newstr7.replace(raptdatetime, this.datepipe.transform(item['AppointmentDate'], 'dd-MMM-yyyy') + " " + item['AppointmentFrom'] + "-" + item['AppointmentTo']);
        var newstr9 = newstr8.replace(rapttime, item['AppointmentFrom'] + "-" + item['AppointmentTo']);

        var newstr10 = newstr9.replace(rfeedbacklink, item['FeedbackLink']);

        var newstr11 = newstr10.replace(raptdate, this.datepipe.transform(item['AppointmentDate'], 'dd-MMM-yyyy'));

        console.log(newstr11);

        return newstr11;

    }

    open_enquiry_form(item) {
        let Sibling = 0;
        let Jd = null;
        if (item) {
            Sibling = 1;
        }
        let EnquiryModel = this.modalCtrl.create(EnquiryFormPage, {SiblingsCalls: Sibling, SiblingsDataCalls: item});
        EnquiryModel.onDidDismiss(data => {
            console.log(data);
            if (data == undefined) {

            } else {
                this.presentToast(data);
            }

            // this.checkCallStatusIsNull();

        });
        EnquiryModel.present();
    }

    select_archive(item) {
        let myAlert = this.alertCtrl.create({
            title: 'Select Archive',
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel',
                    handler: () => {
                        console.log('Cancel clicked');
                    }
                },
                {
                    text: 'Confirm',
                    handler: (data) => {
                        console.log('clicked');
                        console.log(data);

                        let SchoolName = '';
                        if (data == 1) {
                            let myAlert1 = this.alertCtrl.create({
                                title: 'Enter School Name',
                                mode: 'ios',
                                inputs: [
                                    {
                                        name: 'SchoolName',
                                        placeholder: 'School Name'
                                    },
                                ],
                                buttons: [
                                    {
                                        text: 'Cancel',
                                        role: 'cancel',
                                        handler: () => {
                                            console.log('Cancel clicked');
                                        }
                                    },
                                    {
                                        text: 'Confirm',
                                        handler: (data1) => {
                                            console.log('clicked');
                                            console.log(data1.SchoolName);
                                            SchoolName = data1.SchoolName;

                                            let loading = this.loadingCtrl.create({
                                                content: 'Loading'
                                            });
                                            loading.present();

                                            console.log("Id", item.Id);
                                            this.service.httpcall('web_service/update_web_enquiry_as_testing?SchoolName=' + SchoolName + '&CancelledBy=' + this.FUserId + '&Id=' + item.FWebEnquiryId + '&Active=' + 3 + '&ArchiveStatus=' + data).subscribe(data => {
                                                if (loading)
                                                    loading.dismiss();
                                                loading = undefined;
                                                console.log(data);
                                                if (data['response'] == "success") {
                                                    this.presentToast(data['success_message']);
                                                } else {
                                                    this.presentToast(data['error_description']);
                                                }
                                            })
                                        }
                                    }]
                            });

                            myAlert1.present();
                            console.log("Archive1->", data);

                        }
                        else {
                            let loading = this.loadingCtrl.create({
                                content: 'Loading'
                            });
                            loading.present();

                            console.log("Id", item.Id);
                            this.service.httpcall('web_service/update_web_enquiry_as_testing?SchoolName=' + SchoolName + '&CancelledBy=' + this.FUserId + '&Id=' + item.FWebEnquiryId + '&Active=' + 3 + '&ArchiveStatus=' + data).subscribe(data => {
                                if (loading)
                                    loading.dismiss();
                                loading = undefined;
                                console.log(data);
                                if (data['response'] == "success") {
                                    this.presentToast(data['success_message']);
                                } else {
                                    this.presentToast(data['error_description']);
                                }
                            })
                        }


                    }
                }
            ]
        });
        for (var i = 0; i < this.ArchiveStatus.length; i++) {
            this.ArchiveStatusItem = this.ArchiveStatus[i];
            var edata = this.ArchiveStatusItem.Name;
            console.log(edata);
            myAlert.addInput({
                type: 'radio',
                label: edata,
                value: this.ArchiveStatusItem.Id
            })
        }

        myAlert.present();
    }

    add_SubStatus(item) {

        this.SubStatus = null;
        this.SubStatusItem = null;
        this.service.httpcall('web_service/get_master_enquiry_substatus?params[FStatusId]=' + item.DataStatusId).subscribe(data => {
            console.log("getReasons", data);
            if (data['response'] == "success") {
                this.SubStatus = data['data'];
                console.log(this.SubStatus);
                let myAlert = this.alertCtrl.create({
                    title: 'Set SubStatus',
                    buttons: [
                        {
                            text: 'Cancel',
                            role: 'cancel',
                            handler: () => {
                                console.log('Cancel clicked');
                            }
                        },
                        {
                            text: 'Confirm',
                            handler: (data) => {
                                console.log('clicked');
                                console.log(data);

                                this.service.httpcall('web_service/add_subStatus_On_webEnquiryId?FStatusId=' + item.DataStatusId + '&FWebEnquiryId=' + item.FWebEnquiryId + '&FUserId=' + this.FUserId + '&FSubStatusId=' + data).subscribe(data => {
                                    console.log(data);
                                    if (data['response'] == "success") {
                                        this.presentToast(data['success_message']);
                                    } else {
                                        this.presentToast(data['error_description']);
                                    }

                                }, (error2 => {
                                    this.presentToast("Timeout!");
                                }))

                            }
                        }
                    ]
                });
                for (var i = 0; i < this.SubStatus.length; i++) {
                    this.SubStatusItem = this.SubStatus[i];
                    var edata = this.SubStatusItem.SubStatusName;
                    console.log(edata);
                    myAlert.addInput({
                        type: 'radio',
                        label: edata,
                        value: this.SubStatusItem.Id
                    })
                }

                myAlert.present();
            } else {
                this.presentToast(data['error_description']);

            }

        }, (error2 => {
            this.presentToast("Timeout!");

        }))


    }

    edit_enquiry(item) {
        let EnquiryModel = this.modalCtrl.create(EnquiryFormPage, {editDataCalls: item, IsAppointment: 0});
        EnquiryModel.onDidDismiss(data => {
            console.log(data);
            this.presentToast(data);
        });
        EnquiryModel.present();
    }

    get_predata_call_reminder() {
        console.log("load Predata");
        this.searchText = "";

        let loading1 = this.loadingCtrl.create({
            content: 'please wait...',
            enableBackdropDismiss: true
        });

        loading1.present();

        this.pending_enquiry = [];
        this.completed_enquiry = [];

        this.service.httppostcall("app_web_service/get_predata_call_reminder?SchoolId=" + this.SchoolId + '&DayId=' + this.daysStatusId, '').subscribe(data => {
            console.log(data);
            loading1.dismiss();
            this.pending_enquiry = data['pending'];
            this.completed_enquiry = data['completed'];

            this.pending_enquiry1 = this.pending_enquiry;
            this.completed_enquiry1 = this.completed_enquiry;

            this.completedCount = data['completedCount'];
            this.pendingCount = data['pendingCount'];

        });
    }

    predata_whatsapp_call(item) {

        let myAlert = this.alertCtrl.create({
            title: 'Contacts',
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel',
                    handler: () => {
                        console.log('Cancel clicked');
                    }
                },
                {
                    text: 'WhatsApp',
                    handler: (data) => {
                        console.log('Message clicked');
                        console.log(data);
                        if (data) {
                            window.location.href = 'whatsapp://send?phone=+91' + data;
                        } else {
                            this.service.showAlert("Warning!", "Select any one is required!")
                        }
                    }
                }
            ]
        });

        myAlert.addInput({
            type: 'radio',
            label: item.MobileNumber,
            value: item.MobileNumber
        });

        myAlert.present();
    }

    predata_call(item) {
        let myAlert = this.alertCtrl.create({
            title: 'Contacts',
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel',
                    handler: () => {
                        console.log('Cancel clicked');
                    }
                },
                {
                    text: 'Call',
                    handler: (data) => {
                        console.log('Message clicked');
                        console.log(data);

                        if (data) {
                            let loading = this.loadingCtrl.create({
                                content: 'Loading'
                            });
                            loading.present();
                            const jsondata = {
                                'FPredataId': item.FPredataId,
                                'Contact': data,
                                'AddedBy': this.FUserId,
                                'AddedByName': this.userName
                            }

                            this.service.httppostcall('app_web_service/add_predata_call_logs?', jsondata).subscribe(res => {
                                loading.dismiss();
                                console.log(res);
                                if (res['response'] == "success") {
                                    window.location.href = 'tel:' + data;
                                } else {
                                    this.service.showAlert("Error!", res['error_description']);
                                }
                            }, error2 => {
                                this.service.showAlert("Timeout!", "Refresh and Try again..");
                            })
                        } else {
                            this.service.showAlert("Warning!", "Select any one is required!")
                        }


                    }
                }
            ]
        });
        myAlert.addInput({
            type: 'radio',
            label: item.MobileNumber,
            value: item.MobileNumber
        })

        myAlert.present();
    }

    predata_gotoCallLogs(item) {
        if (item.CallLogsCount != 0) {
            let Model = this.modalCtrl.create(PredataCallLogsPage, {data: item.CallLogs});
            Model.present();
        }
    }

    predata_change_call_status(item) {
      console.log("send_data item->", item);

      let send_data = {
        FPredataId: item.FPredataId,
        ReminderDate: item.ReminderDate,
        CreatedByName: this.userName,
        FUserId: this.FUserId,
        Comment:item.Comment
      };


      console.log("send_data->", send_data);

      this.CallStatus = null;
        this.CallStatusItem = null;

        this.service.httpcall('web_service/get_master_call_log_status?').subscribe(data => {
            console.log("get_master_call_log_status", data);
            if (data != "") {
                this.CallStatus = data;
                console.log(this.CallStatus);

                let myAlert = this.alertCtrl.create({
                    title: 'Set Call Status',
                    buttons: [
                        {
                            text: 'Cancel',
                            role: 'cancel',
                            handler: () => {
                                console.log('Cancel clicked');
                            }
                        },
                        {
                            text: 'Confirm',
                            handler: (data) => {
                                console.log('clicked');
                                console.log(data, " ", item);

                                if (data) {


                                    this.FCallStatusId = data;

                                    if (data == 11 || data == 12) {
                                        //positive call status
                                        const params = {
                                            FCallReminderId: item.ReminderId,
                                            FCallStatusId: data,
                                            IsJustDialData: item.IsJustDialData,
                                            FPredataId: item.FPredataId,
                                            MobileNumber: item.MobileNumber,
                                            Name: item.Name,
                                            SourceId: item.SourceId,
                                            FSchoolId: item.FSchoolId,
                                            Id: item.FPredataId
                                        }
                                        console.log("FPredataId->",params)
                                        this.predata_call_status_alert(params);
                                    }
                                    else if (data == 10) {
                                        //add new reminder

                                        const dataobj = {
                                            FPredataId: item.FPredataId,
                                            CallStatusId:data
                                        }

                                        let EnquiryModel = this.modalCtrl.create(AddPredataCallReminderPage, {predata: dataobj});
                                        EnquiryModel.onDidDismiss(res => {
                                            console.log(res);
                                            if (res != 0) {
                                                let loading2 = this.loadingCtrl.create({
                                                    content: 'Please wait...'
                                                });
                                                loading2.present();

                                                this.service.httppostcall('app_web_service/add_callStatus_On_predata_reminder?FCallReminderId=' + item.ReminderId + '&FCallStatusId=' + data + '&FUserId=' + this.FUserId + '&UpdatedByName=' + this.userName, send_data).subscribe(data1 => {
                                                    console.log(data1);
                                                    if (data1['status'] == "success") {
                                                        loading2.dismiss();
                                                        this.service.showToast(res);
                                                        this.active_status_pending_tab(this.StatusPending, this.pendingorCompleted);
                                                    } else {
                                                        loading2.dismiss();
                                                    }
                                                }, (error2 => {
                                                    loading2.dismiss();
                                                }))
                                            }
                                        });
                                        EnquiryModel.present();

                                    }
                                    else {

                                        let loading = this.loadingCtrl.create({
                                            content: 'Please wait...'
                                        });
                                        loading.present();


                                        this.service.httppostcall('app_web_service/add_callStatus_On_predata_reminder?FCallReminderId=' + item.ReminderId + '&FCallStatusId=' + data + '&FUserId=' + this.FUserId + '&UpdatedByName=' + this.userName, '').subscribe(data1 => {
                                            console.log(data1);
                                            loading.dismiss();
                                            if (data1['status'] == "success") {
                                                this.active_status_pending_tab(this.StatusPending, this.pendingorCompleted);
                                            } else {
                                                loading.dismiss();
                                            }
                                        }, (error2 => {
                                            loading.dismiss();
                                        }))
                                    }
                                } else {
                                    this.service.showAlert("Warning!", "Select any one is required!")
                                }

                            }
                        }
                    ]
                });

                for (var i = 0; i < this.CallStatus.length; i++) {
                    this.CallStatusItem = this.CallStatus[i];
                    var edata = this.CallStatusItem.Name;
                    console.log(edata);
                    myAlert.addInput({
                        type: 'radio',
                        label: edata,
                        value: this.CallStatusItem.Id
                    })
                }

                myAlert.present();
            } else {
                //this.presentToast(data['error_description']);
            }
        }, (error2 => {
            //this.presentToast("Timeout!");
        }))
    }

    predata_call_status_alert(params) {


        let myAlert = this.alertCtrl.create({
            title: 'Update Status',
            enableBackdropDismiss: false,
            buttons: [
                {
                    text: '+ Data',
                    handler: (data) => {
                        this.predata_enquiry_form(params);
                    }
                },
                {
                    text: 'Archive',
                    handler: (data) => {
                        this.Gust_select_archive(params);
                    }
                },
                {
                    text: 'Add Reminder',
                    handler: (data) => {

                        const dataobj = {
                            FPredataId: params.FPredataId,
                            CallStatusId: params.FCallStatusId
                        }

                        let EnquiryModel = this.modalCtrl.create(AddPredataCallReminderPage, {predata: dataobj});
                        EnquiryModel.onDidDismiss(res => {
                            console.log(res);
                            if (res != 0) {
                                let loading = this.loadingCtrl.create({
                                    content: 'Please wait...'
                                });
                                loading.present();

                                this.service.httppostcall('app_web_service/add_callStatus_On_predata_reminder?FCallReminderId=' + params.FCallReminderId + '&FCallStatusId=' + params.FCallStatusId + '&FUserId=' + this.FUserId + '&UpdatedByName=' + this.userName, '').subscribe(data1 => {
                                    console.log(data1);
                                    if (data1['status'] == "success") {
                                        loading.dismiss();
                                        this.service.showToast(res);
                                        this.active_status_pending_tab(this.StatusPending, this.pendingorCompleted);
                                    } else {
                                        loading.dismiss();
                                    }
                                }, (error2 => {
                                    loading.dismiss();
                                }))
                            }
                        });
                        EnquiryModel.present();


                    }
                },
                {
                    text: 'Cancel',
                    role: 'cancel',
                    cssClass: 'alertCancleCss',
                    handler: () => {
                        console.log('Cancel clicked');
                    }
                },

            ]
        });

        myAlert.present();
    }

    predata_enquiry_form(item) {

        const data = {
            MobileNumber: item.MobileNumber,
            Name: item.Name,
            SourceId: item.SourceId,
            FSchoolId: item.FSchoolId,
            Id: item.FPredataId
        }


        let EnquiryModel = this.modalCtrl.create(EnquiryFormPage, {dataPlus: data});
        EnquiryModel.onDidDismiss(res => {
            console.log(res);
            if (res != 0) {
                let loading = this.loadingCtrl.create({
                    content: 'Please wait...'
                });
                loading.present();
                this.service.httppostcall('app_web_service/add_callStatus_On_predata_reminder?FCallReminderId=' + item.FCallReminderId + '&FCallStatusId=' + item.FCallStatusId + '&FUserId=' + this.FUserId + '&UpdatedByName=' + this.userName, '').subscribe(data1 => {
                    console.log(data1);
                    if (data1['status'] == "success") {

                        this.active_status_pending_tab(this.StatusPending, this.pendingorCompleted);
                    } else {
                        loading.dismiss();
                    }
                }, (error2 => {
                    loading.dismiss();
                }))
            }
        });
        EnquiryModel.present();

    }

    Gust_select_archive(item) {
        let myAlert = this.alertCtrl.create({
            title: 'Select Archive',
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel',
                    handler: () => {
                        console.log('Cancel clicked');
                    }
                },
                {
                    text: 'Confirm',
                    handler: (data) => {
                        console.log('clicked');
                        console.log(data);

                        let loading = this.loadingCtrl.create({
                            content: 'Loading'
                        });
                        loading.present();

                        console.log("Id", item.Id);

                        this.service.httpcall('web_service/archive_guest_app_login?Id=' + item.FPredataId + '&IsJustDialData=' + item.IsJustDialData + '&ArchiveFor=' + data + '&ArchiveBy=' + this.FUserId).subscribe(data => {

                            console.log(data);
                            if (data['response'] == "success") {
                                this.presentToast(data['success_message']);

                                this.service.httppostcall('app_web_service/add_callStatus_On_predata_reminder?FCallReminderId=' + item.FCallReminderId + '&FCallStatusId=' + item.FCallStatusId + '&FUserId=' + this.FUserId + '&UpdatedByName=' + this.userName, '').subscribe(data1 => {
                                    console.log(data1);
                                    loading.dismiss();
                                    if (data1['status'] == "success") {
                                        this.active_status_pending_tab(this.StatusPending, this.pendingorCompleted);
                                    } else {
                                        loading.dismiss();
                                    }
                                }, (error2 => {
                                    loading.dismiss();
                                }))

                            } else {
                                this.service.showAlert('Error!', data['error_description'])
                            }
                        })

                    }
                }
            ]
        });
        for (var i = 0; i < this.ArchiveStatus.length; i++) {
            this.ArchiveStatusItem = this.ArchiveStatus[i];
            var edata = this.ArchiveStatusItem.Name;
            console.log(edata);
            myAlert.addInput({
                type: 'radio',
                label: edata,
                value: this.ArchiveStatusItem.Id
            })
        }

        myAlert.present();
    }

    predata_comment(item){
        let alert = this.alertCtrl.create({
            title: 'Add Comment',
            inputs: [
                {
                    name: 'Comment',
                    placeholder: 'Comment'
                }
            ],
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel',
                    handler: data => {
                        console.log('Cancel clicked');
                    }
                },
                {
                    text: 'submit',
                    handler: data => {
                        console.log("data.Comment->",data.Comment)
                        if(data.Comment){
                            let loading = this.loadingCtrl.create({
                                content: 'Please wait...'
                            });
                            loading.present();

                            this.service.httppostcall('app_web_service/add_comment_call_reminder_predata_by_id?FPredataId=' + item.FPredataId + '&Comment=' + data.Comment, '').subscribe(data1 => {
                                console.log(data1);
                                if (data1['response'] == "success") {
                                    loading.dismiss();
                                    this.service.showToast(data1['message']);
                                    this.active_status_pending_tab(this.StatusPending, this.pendingorCompleted);
                                } else {
                                    loading.dismiss();
                                }
                            }, (error2 => {
                                loading.dismiss();
                            }))
                        }else{
                            this.service.showToast("Enter Comment!");
                        }

                    }
                }
            ]
        });
        alert.present();
    }

}



// WEBPACK FOOTER //
// ./src/pages/call-enquiry-reminder/call-enquiry-reminder.ts